import { NgModule } from 'ng-metadata/core';

// Components
import { ContentStreamBackToTopComponent } from './back-to-top/back-to-top.component';
import { ContentStreamComponent } from './content-stream.component';
import { LoadingStateComponent } from './loading-state/loading-state.component';
import { DisplayOptionsComponent } from './display-options/display-options.component';
import { DisplayOptionsService } from './display-options/display-options.service';
import { SortMenuComponent } from './sort-menu/sort-menu.component';
import { BannerComponent } from './banner/banner.component';
import { StatusBarComponent } from './status-bar/status-bar.component';
// Content Selector
import { ContentSelectorTabsComponent } from './content-selector-tabs/content-selector-tabs';
import { ContentSelectorTabComponent } from './content-selector-tabs/content-selector-tab';

/**
 * @ngdoc module
 * @name mw.components.contentStream
 * @description
 *
 *
 */
@NgModule({
    declarations: [
        ContentStreamBackToTopComponent,
        ContentStreamComponent,
        BannerComponent,
        DisplayOptionsComponent,
        LoadingStateComponent,
        SortMenuComponent,
        ContentSelectorTabsComponent,
        ContentSelectorTabComponent,
        StatusBarComponent
    ],
    providers: [ {provide: 'mwCSDisplayOptionsService', useClass: DisplayOptionsService } ]
})

export class ContentStreamModule {}



// WEBPACK FOOTER //
// ./src/lib/components/content-stream/content-stream.module.ts